import React from "react";
import { CloseButton } from "react-bootstrap";
import ChartDialogMenu, {
  ChartDialogMenuParam,
} from "../common/ChartDialogMenu";
import "../../../../../App.css";
import { IModelEvaluationDataRow } from "../../../../../webapi/service/getModelEvaluationData";
import { useTranslation } from "react-i18next";

export interface Props extends ChartDialogMenuParam {
  /**
   * ダイアログを表示するの場合true,それ以外の場合falseを設定します
   */
  open: boolean;
  /**
   * 表示するチャートのIDを設定します
   */
  chartid: string;
  /**
   * 閉じるボタンがクリックされた場合に呼び出されます
   */
  onClose?: () => void;
  /**
   * モデル評価結果の情報
   */
  modelevalinfo?: IModelEvaluationDataRow;
}

/**
 * チャートダイアログを表示します
 * @param {Props} props - ダイアログパラメータ
 * @returns チャートダイアログ
 */
export default function ChartDialog(props: Props) {
  const {
    open,
    chartid,
    onClose,
    edit,
    editMenu,
    onXZoomUp,
    onXZoomOut,
    onYZoomUp,
    onYZoomOut,
    id,
    x,
    range,
    onRegist,
    modelevalinfo,
  } = props;
  const { t } = useTranslation();
  const correction =
    !edit || !editMenu ? <span style={{ marginLeft: "25px" }}></span> : "";
  
  function createInfo():JSX.Element {
    let contents = <div />
    if (modelevalinfo) {
      contents = (
        <div style={{ marginTop: "50px" }}>
          <div>{t("info_settlingtime")}</div> <div>{modelevalinfo?.settlingtime}</div>
          <div>{t("info_risetime")}</div> <div>{modelevalinfo?.risetime}</div>
          <div>{t("info_overshoot")}</div> <div>{modelevalinfo?.overshoot}</div>
          <div>{t("info_offset")}</div> <div>{modelevalinfo?.offset}</div>
          <div>{t("info_stability")}</div> <div>{modelevalinfo?.stability}</div>
        </div>
      );
    }    
    return contents;
  }
  const info = createInfo();
  const modelEvalInfo = modelevalinfo ? 
    <div>{info}</div> : "";
  const chartidIn = chartid + "_in"
  const chartidOut = chartid + "_out"
  return (
    <dialog open={open} className="dialog-tag-pos">
      <div className="dialog-container">
        <div className="out"><div id={chartidOut}></div></div>
        <div className="in"><div id={chartidIn}></div></div>
        <div className="menu">
          <ChartDialogMenu
            edit={edit}
            editMenu={editMenu}
            onXZoomUp={onXZoomUp}
            onXZoomOut={onXZoomOut}
            onYZoomUp={onYZoomUp}
            onYZoomOut={onYZoomOut}
            id={id}
            x={x}
            range={range}
            onRegist={onRegist}
          />
          {modelEvalInfo}
        </div>
        <div className="close">{correction}
        <CloseButton onClick={onClose} /></div>
      </div>
    </dialog>
  );
}
